import React from "react";
import { LogoNexsoft } from "../../../asset";
import {
  LabelDetail,
  ValueDetail,
  ValueImage,
} from "../../../component/page-components/detail";
import useCompanyProfile from "./company-profile.hooks";
import ModalPhoto from "../../../component/modal/ModalPhoto";

const DetailProfile = () => {
  const { data, isViewDetailPhoto, setIsViewDetailPhoto, viewDetail } =
    useCompanyProfile();

  return (
    <>
      <div className=" mt-10 flex flex-col">
        <p className=" font-roboto text-lg text-black-100 font-bold">
          Company Information
        </p>
        <div className=" mt-3 flex flex-row gap-2">
          <div className=" w-96">
            <LabelDetail children="Company Logo" />
            <ValueImage
              sources={data?.company_logo ? data?.company_logo : LogoNexsoft}
              alt="logo-nexsoft"
              onViewDetailPhoto={viewDetail}
            />

            <LabelDetail children="Company Phone Number" />
            <ValueDetail
              children={data?.company_phone ? data?.company_phone : "-"}
            />
          </div>
          <div className=" w-96">
            <LabelDetail children="GroLog Account ID" />
            <ValueDetail
              children={
                data?.company_profile_id ? data?.company_profile_id : "-"
              }
            />

            <LabelDetail children="Company Name" />
            <ValueDetail
              children={data?.company_name ? data?.company_name : "-"}
            />

            <LabelDetail children="Company Tax Number" />
            <ValueDetail
              children={
                data?.company_npwp
                  ? data?.company_npwp.replaceAll(/[.-]/g, "")
                  : "-"
              }
            />

            <LabelDetail children="Company Fax Number" />
            <ValueDetail
              children={data?.company_fax ? data?.company_fax : "-"}
            />
          </div>
          <div className=" w-96">
            <LabelDetail children="Company Title" />
            <ValueDetail
              children={data?.company_title ? data?.company_title : "-"}
            />

            <LabelDetail children="Company Status" />
            <ValueDetail
              children={data?.company_status ? data?.company_status : "-"}
            />

            <LabelDetail children="Company Email" />
            <ValueDetail
              children={data?.company_email ? data?.company_email : "-"}
            />
          </div>
        </div>
        <p className=" font-roboto text-lg text-black-100 font-bold mt-3">
          Address Information
        </p>
        <div className=" mt-3 flex flex-row gap-2">
          <div className=" w-96">
            <LabelDetail children="Company Country" />
            <ValueDetail
              children={data?.company_country ? data?.company_country : "-"}
            />

            <LabelDetail children="Company District" />
            <ValueDetail
              children={data?.company_district ? data?.company_district : "-"}
            />

            <LabelDetail children="Company Address" />
            <ValueDetail
              children={data?.company_address_1 ? data?.company_address_1 : "-"}
            />

            <LabelDetail children="Company Neighbourhood" />
            <ValueDetail
              children={data?.company_neighbour ? data?.company_neighbour : "-"}
            />

            <LabelDetail children="Company Longitude" />
            <ValueDetail children={data?.longitude ? data?.longitude : "-"} />
          </div>
          <div className=" w-96">
            <LabelDetail children="Company Island" />
            <ValueDetail
              children={data?.company_island ? data?.company_island : "-"}
            />

            <LabelDetail children="Company Sub District" />
            <ValueDetail
              children={
                data?.company_sub_district ? data?.company_sub_district : "-"
              }
            />

            <LabelDetail children="Company Address 2" />
            <ValueDetail
              children={data?.company_address_2 ? data?.company_address_2 : "-"}
            />

            <LabelDetail children="Company Hamlet" />
            <ValueDetail
              children={data?.company_hamlet ? data?.company_hamlet : "-"}
            />

            <LabelDetail children="Company Lattitude" />
            <ValueDetail children={data?.latitude ? data?.latitude : "-"} />
          </div>
          <div className=" w-96">
            <LabelDetail children="Company Province" />
            <ValueDetail
              children={data?.company_province ? data?.company_province : "-"}
            />

            <LabelDetail children="Company Urban Village" />
            <ValueDetail
              children={
                data?.company_urban_village ? data?.company_urban_village : "-"
              }
            />

            <LabelDetail children="Company Address 3" />
            <ValueDetail
              children={data?.company_address_3 ? data?.company_address_3 : "-"}
            />

            <LabelDetail children="Company Postal Code" />
            <ValueDetail
              children={
                data?.company_postal_code ? data?.company_postal_code : "-"
              }
            />
          </div>
        </div>
        
        <p className=" font-roboto text-lg text-black-100 font-bold mt-3">
          Bank Account
        </p>
        <div className=" mt-3 flex flex-row gap-2">
          <div className=" w-96">
            <LabelDetail children="Name of Bank" />
            <ValueDetail
              children={data?.bank_name ? data?.bank_name : "-"}
            />
            </div>
            <div className=" w-96">
            <LabelDetail children="Bank Account Number" />
            <ValueDetail
              children={data?.bank_account_number ? data?.bank_account_number : "-"}
            />
            </div>
            </div>
        <ModalPhoto
          photo={data?.company_logo}
          show={isViewDetailPhoto}
          img={data?.company_logo}
          onClose={() => setIsViewDetailPhoto(false)}
        />
      </div>
    </>
  );
};

export default DetailProfile;
